import {
  AVAILABILITY_LOADING,
  AVAILABILITY_SUCCESS,
  AVAILABILITY_ERROR
} from '../actions/availabilityActions';

const INITIAL_STATE = {
  status: 'init',
};

export default function availabilityReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case AVAILABILITY_LOADING:
      return { ...state, status: 'loading' };

    case AVAILABILITY_SUCCESS:
      return { availableTimes: action.payload.data.data || [], status: 'success' };

    case AVAILABILITY_ERROR:
      const { status, statusText } = action.payload.response;
      const { message } = action.payload;

      return { error: { status, statusText, message } };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/availabilityReducer.js